import { render, staticRenderFns } from "./CustomizeLayout.vue?vue&type=template&id=4da0ee3a&scoped=true&"
import script from "./CustomizeLayout.vue?vue&type=script&lang=js&"
export * from "./CustomizeLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeLayout.vue?vue&type=style&index=0&id=4da0ee3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0ee3a",
  null
  
)

export default component.exports